/** Normalize product list responses from our FastAPI API. */
export function normalizeProductList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.products)) return data.products;
  return [];
}

/** True when the backend health check indicates the API is up. */
export function isOoriFastApiHealth(data) {
  if (!data || typeof data !== "object") return false;
  if (data.service === "oori-label-api") return true;
  const status = String(data.status || "").toLowerCase();
  // Accept ok / degraded — degraded means Mongo blip but static catalog still works.
  return status === "ok" || status === "degraded";
}
